const DownloadSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M2.66602 11.3327V12.666C2.66602 13.0196 2.80649 13.3588 3.05654 13.6088C3.30659 13.8589 3.64573 13.9993 3.99935 13.9993H11.9993C12.353 13.9993 12.6921 13.8589 12.9422 13.6088C13.1922 13.3588 13.3327 13.0196 13.3327 12.666V11.3327M4.66602 7.33268L7.99935 10.666M7.99935 10.666L11.3327 7.33268M7.99935 10.666V2.66602"
        stroke="#333333"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DownloadSvg;
